export default __webpack_public_path__ + "static/media/279.9049f3d0.png";